document.addEventListener('DOMContentLoaded', function() {
  let registerCallback = null;
  let qrCodeUrlCallback = null; // Global variable to store qr_code_url
  
  const otpInputs = document.querySelectorAll('.otp-input');
  const verifyBtn = document.getElementById('twofa-verify');
  const errorDiv = document.getElementById('twofa-error');

  // Show info message (success)
  function showInfo(msg) {
    errorDiv.textContent = msg;
    errorDiv.classList.remove('twofa-error');
    errorDiv.classList.add('twofa-info');
    errorDiv.style.display = 'block';
  }
  // Show error message
  function showError(msg) {
    errorDiv.textContent = msg;
    errorDiv.classList.remove('twofa-info');
    errorDiv.classList.add('twofa-error');
    errorDiv.style.display = 'block';
  }
  function hideError() {
    errorDiv.style.display = 'none';
  }

  function isRegisterPage() {
    return window.location.pathname.includes('/register');
  }

  function isAddressesPage() {
    return window.location.pathname.includes('/account/addresses');
  }

  function verifyOTP(callback = null) {
    let code;
    const otpSection = document.getElementById('otp-section');
    const recoverySection = document.getElementById('recovery-section');
    if (recoverySection && recoverySection.style.display === 'block') {
      code = document.getElementById('recovery-code-input').value.trim();
      if (!code) {
        showError('リカバリーコードを入力してください');
        return;
      }
    } else {
      code = getOTPValue();
      if (!code || code.length !== 6) {
        showError('認証コードを入力してください');
        return;
      }
    }
    verifyBtn.disabled = true;
    verifyBtn.textContent = '認証中...';
    hideError();
    // Prepare payload
    let payload = { code: code };
    if (isRegisterPage()) {
      const email = document.getElementById('RegisterForm-email')?.value || '';
      const method = document.querySelector('input[name="customer[note][method_2fa]"]:checked')?.value;
      payload.email = email;
      payload.method = method;
      payload.is_register = true;
    }
    if (isAddressesPage()) {
        var method2faEmail = document.getElementById('method_2fa_email');
        var method2faApplication = document.getElementById('method_2fa_application');
        var method = method2faEmail.checked ? 'email' : (method2faApplication.checked ? 'application' : 'email');
        payload.method = method;
        payload.request_2fa = true;
    }
    fetchBase(
      `${mallDomain}/admin/2fa/verify`,
      (result) => {
        if (result.success) {
          if (isRegisterPage() || isAddressesPage()) {
            callback(qrCodeUrlCallback);
          } else {
            document.cookie = "__request_2fa=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
            window.location.href = '/';
          }
        } else {
          if (isRegisterPage() || isAddressesPage()) {
            showError('認証コードが正しくありません');
            otpInputs.forEach(el => {
              el.value = '';
            });
            otpInputs[0].focus();
          } else {
            window.location.href = '/account/login?error_code=invalid_otp';
          }
        }
        verifyBtn.disabled = false;
        verifyBtn.textContent = '認証';
      },
      'POST',
      payload,
      false
    );
  }

  // Get OTP value from all inputs
  function getOTPValue() {
    return Array.from(otpInputs).map(input => input.value).join('');
  }

  // Set OTP value to all inputs
  function setOTPValue(value) {
    const digits = value.split('');
    otpInputs.forEach((input, index) => {
      input.value = digits[index] || '';
      input.classList.toggle('filled', digits[index] ? true : false);
    });
  }

  // Handle input navigation
  function handleInputNavigation(currentInput) {
    const currentIndex = parseInt(currentInput.dataset.index);
    const value = currentInput.value;

    if (value && currentIndex < 5) {
      // Move to next input
      otpInputs[currentIndex + 1].focus();
    } else if (!value && currentIndex > 0) {
      // Move to previous input on backspace
      otpInputs[currentIndex - 1].focus();
    }
  }
  

  // Handle input events
  otpInputs.forEach(input => {
    input.addEventListener('input', function(e) {
      const value = e.target.value;
      
      // Only allow numbers
      if (!/^\d*$/.test(value)) {
        e.target.value = value.replace(/\D/g, '');
        return;
      }

      // Update filled state
      e.target.classList.toggle('filled', value ? true : false);
      
      // Handle navigation
      handleInputNavigation(e.target);
      
      // Auto verify when all 6 digits are entered
      const otpValue = getOTPValue();

      if (otpValue.length === 6) {
        verifyOTP(registerCallback);
      }
    });

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Backspace' && !e.target.value) {
        // Move to previous input on backspace when current is empty
        const currentIndex = parseInt(e.target.dataset.index);
        if (currentIndex > 0) {
          otpInputs[currentIndex - 1].focus();
        }
      }
    });

    input.addEventListener('paste', function(e) {
      e.preventDefault();
      const pastedData = e.clipboardData.getData('text');
      const digits = pastedData.replace(/\D/g, '').slice(0, 6);
      setOTPValue(digits);
      
      // Auto verify if 6 digits
      if (digits.length === 6) {
        verifyOTP(registerCallback);
      }
    });
  });

  (function() {

    // When on register page, wrap .twofa-container into overlay and insert close button if not exists
    if (isRegisterPage()) {
      var container = document.querySelector('.twofa-container');
      if (container && !document.getElementById('twofa-modal-overlay')) {
        var overlay = document.createElement('div');
        overlay.id = 'twofa-modal-overlay';
        overlay.style.display = 'none';
        overlay.style.position = 'fixed';
        overlay.style.zIndex = '9999';
        overlay.style.left = '0';
        overlay.style.top = '0';
        overlay.style.width = '100vw';
        overlay.style.height = '100vh';
        overlay.style.background = 'rgba(0,0,0,0.5)';
        overlay.style.alignItems = 'center';
        overlay.style.justifyContent = 'center';
        container.parentNode.insertBefore(overlay, container);
        overlay.appendChild(container);
        // Add close button if not exists
        if (!document.getElementById('twofa-modal-close')) {
          var closeBtn = document.createElement('button');
          closeBtn.id = 'twofa-modal-close';
          closeBtn.textContent = '×';
          closeBtn.style.position = 'absolute';
          closeBtn.style.top = '8px';
          closeBtn.style.right = '12px';
          closeBtn.style.fontSize = '24px';
          closeBtn.style.background = 'none';
          closeBtn.style.border = 'none';
          closeBtn.style.color = '#333';
          closeBtn.style.cursor = 'pointer';
          closeBtn.style.zIndex = '10001';
          container.style.position = 'relative';
          container.insertBefore(closeBtn, container.firstChild);
        }
      }
      // Ensure overlay is always hidden when entering page
      var overlay = document.getElementById('twofa-modal-overlay');
      if (overlay) overlay.style.display = 'none';
      // Close modal when close button is clicked
      var closeBtn = document.getElementById('twofa-modal-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function() {
          window.show2FAPopup(false);
        });
      }
    }

    function sendOTP(callback) {
      let postData = {};
      if (isRegisterPage()) {
        // Get method and email from form registration
        const method = document.querySelector('input[name="customer[note][method_2fa]"]:checked')?.value;
        const email = document.getElementById('RegisterForm-email')?.value || '';
        const is_register = true;
        postData = { method, email, is_register };
      }
      if (isAddressesPage()) {
        const request_2fa = true;
        var method2faEmail = document.getElementById('method_2fa_email');
        var method2faApplication = document.getElementById('method_2fa_application');
        var method = method2faEmail.checked ? 'email' : (method2faApplication.checked ? 'application' : 'email');
        postData = { request_2fa, method };
      }
      
      fetchBase(
        `${mallDomain}/admin/2fa/send-otp`,
        (result) => {
          qrCodeUrlCallback = result.qr_code_url || null;
          if (result.two_factor_enabled || isRegisterPage()) {
            // Use window.method_2fa to determine the type of 2FA
            const setupDiv = document.getElementById('application-setup');
            if ((window.method_2fa === 'application' || isRegisterPage()) && setupDiv) {
              setupDiv.innerHTML = '';
              if (result.qr_code_url) {
                if (result.qr_code_url.startsWith('<?xml')) {
                  setupDiv.innerHTML += `
                    <div style="margin-bottom: 15px;">
                      <p style="font-size:14px;font-weight:500;margin-bottom:15px;">認証アプリで下のQRコードをスキャンしてください。</p>
                      ${result.qr_code_url}
                    </div>
                  `;
                } else {
                  setupDiv.innerHTML += `
                    <div style="margin-bottom: 15px;">
                      <p style="font-size:14px;font-weight:500;margin-bottom:15px;">認証アプリで下のQRコードをスキャンしてください。</p>
                      <img src="${result.qr_code_url}" alt="Authenticator QR Code" style="width:120px;height:120px;">
                    </div>
                  `;
                }
              }
              if (result.secret) {
                setupDiv.innerHTML += `
                  <p style="font-size:13px;color:#888;">
                    または手動でシークレットキーを入力: <b>${result.secret}</b>
                  </p>
                `;
              }
              // Display recovery codes if available
              if (result.recovery_codes && result.recovery_codes.length > 0) {
                // check if exist secret, then hide setup
                const leftCol = document.querySelector('.twofa-modal-col1');
                if (leftCol) leftCol.style.display = 'block';
                
                // Hide link using recovery code if no recovery_codes
                document.getElementById('show-recovery').style.display = 'none';
                
                const downloadDiv = document.getElementById('recovery-codes-download');
                // const col1 = document.getElementById('recovery-codes-col1');
                // const col2 = document.getElementById('recovery-codes-col2');
                const codes = result.recovery_codes;
                const half = Math.ceil(codes.length / 2);
                const codes1 = codes.slice(0, half);
                const codes2 = codes.slice(half);
                // col1.innerHTML = codes1.map((code, idx) => `${idx + 1}. ${code}`).join('<br>');
                // col2.innerHTML = codes2.map((code, idx) => `${idx + 1 + half}. ${code}`).join('<br>');
                downloadDiv.style.display = 'block';
                document.getElementById('download-recovery-codes').addEventListener('click', function(e) {
                  e.preventDefault();
                  let date = new Date();
                  const formattedCodes = codes.map((code, index) => `${index + 1}. ${code}`).join('\n');
                  const contentEmail = document.getElementById('RegisterForm-email')?.value || '';
                  const contentData = "花結リカバリｰコード\nAccount email: "+ contentEmail + "\nGenerated: "+date.getFullYear()+"-"+date.getMonth()+"-"+date.getDate()+" "+date.getHours()+":"+date.getMinutes()+":"+date.getSeconds();
                  const contentMsg = "デバイスにアクセスできなくなった場合は、リカバリーコードを使ってログインできます。\n各コードは一度しか使用できません。\n新しいリカバリーコードを生成すると、これらのコードは無効になります。";
                  const content = contentData+`\n\n${formattedCodes}\n\n` + contentMsg;
                  const blob = new Blob([content], { type: 'text/plain' });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = 'recovery-codes.txt';
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  URL.revokeObjectURL(url);
                });
              } else {
                // Display link using recovery code if login
                document.getElementById('show-recovery').style.display = 'display';
              }
            } 
            if (!isRegisterPage()) {
              if (window.method_2fa === 'application') {
                showInfo('認証アプリで認証コードを確認してください。');
              } else {
                showInfo("認証コードを送信しました。メールをご確認ください。");
              }
            }
          } else {
            if (!isRegisterPage()) showError('2要素認証が有効ではありません。');
          }
          if (typeof callback === 'function') callback(result.qr_code_url);
        },
        'POST',
        postData,
        false
      );
    }

    // Convert UI between OTP and recovery code
    document.getElementById('show-recovery').addEventListener('click', function(e) {
      e.preventDefault();
      document.getElementById('otp-section').style.display = 'none';
      document.getElementById('recovery-section').style.display = 'block';
    });

    document.getElementById('show-otp').addEventListener('click', function(e) {
      e.preventDefault();
      document.getElementById('recovery-section').style.display = 'none';
      document.getElementById('otp-section').style.display = 'block';
    });

    document.getElementById('recovery-code-input').addEventListener('keypress', function(e) {
      if (e.key === 'Enter') verifyOTP(registerCallback);
    });

    verifyBtn.addEventListener('click', verifyOTP);
    otpInputs[0].addEventListener('keypress', function(e) {
      if (e.key === 'Enter') verifyOTP(registerCallback);
    });

    // Expose for register page call when needed
    window.init2FARegister = function(callback) {
      registerCallback = callback;
      
      // Show popup with loading indicator
      window.show2FAPopup(true, true);
      
      // Call API to get data
      sendOTP(function(qrCodeUrl) {
        // Hide loading indicator and show content by calling show2FAPopup
        window.show2FAPopup(true, false);
      });
    };

    // Expose for toggle page call when needed
    window.init2FAToggle = function(callback) {
      registerCallback = callback;
      
      // Show popup with loading indicator
      window.show2FAPopup(true, true);
      
      // Call API to get data
      sendOTP(function(qrCodeUrl) {
        // Hide loading indicator and show content by calling show2FAPopup
        window.show2FAPopup(true, false);
        
        // Reset OTP inputs and focus
        otpInputs.forEach(el => {
          el.value = '';
        });
        otpInputs[0].focus();
      });
    };

    // Expose for toggle popup call when needed
    window.show2FAPopup = function(isOpen, showLoading = false) {
      var overlay = document.getElementById('twofa-modal-overlay');
      const loadingDiv = document.querySelector('.twofa-loading');
      const twofaModalFlex = document.querySelector('#otp-section');
      const twofaInstruction = document.querySelector('#twofa-instruction');
      const twofaVerifyBtn = document.querySelector('#twofa-verify');
      
      if (overlay) overlay.style.display = isOpen ? 'flex' : 'none';
      
      if (isOpen && showLoading) {
        // Show loading indicator, hide content sections
        loadingDiv.style.display = 'block';
        twofaModalFlex.style.display = 'none';
        twofaInstruction.style.display = 'none';
        twofaVerifyBtn.style.display = 'none';
      } else if (isOpen && !showLoading) {
        // Hide loading indicator, show content sections
        loadingDiv.style.display = 'none';
        twofaInstruction.style.display = 'block';
        twofaVerifyBtn.style.removeProperty('display');
        twofaModalFlex.style.display = 'block';
        
      }
      // When isOpen = false, just hide overlay (no need to manipulate child elements)
    };

    // If not register page or addresses page, automatically sendOTP when entering page
    if (!isRegisterPage() && !isAddressesPage()) {
      sendOTP(null);
    }
  })();
}); 